import { ListAltOutlined } from '@mui/icons-material';
import { Widget, WidgetContent, WidgetHeader, WidgetIcon, useScrollIntoView } from '@procureai/ui-mui';
import { useTranslation } from 'react-i18next';

import { I18nNamespace } from '~/common/types';

import { AbsenceGridForm } from './components/UserProfileAbsenceGridForm/UserProfileAbsenceGridForm';

export const UserProfileAbsenceWidget = () => {
  const { t } = useTranslation(I18nNamespace.widgets, { keyPrefix: 'UserProfileAbsenceWidget' });
  const [widgetRef, active] = useScrollIntoView({ hash: '' });

  return (
    <Widget ref={widgetRef} active={active} hover={false} data-intercom-target="UserProfileAbsenceWidget">
      <WidgetHeader icon={<WidgetIcon icon={<ListAltOutlined fontSize="small" />} />} title={t('title')} />
      <WidgetContent>
        <AbsenceGridForm />
      </WidgetContent>
    </Widget>
  );
};
